/** Where to send the person after sign-in when a 401 cleared the session mid-work. */
export const RETURN_HASH_KEY = 'alder:return-hash';

export function rememberReturnHash(hash = window.location.hash): void {
  const value = hash.replace(/^#/, '').split('?')[0] || '';
  if (!value || value === 'home') return;
  try { sessionStorage.setItem(RETURN_HASH_KEY, value); } catch { /* private mode */ }
}

export function clearReturnHash(): void {
  try { sessionStorage.removeItem(RETURN_HASH_KEY); } catch { /* private mode */ }
}

export function takeReturnHash(): string | null {
  try {
    const value = sessionStorage.getItem(RETURN_HASH_KEY);
    sessionStorage.removeItem(RETURN_HASH_KEY);
    return value && value !== 'home' ? value : null;
  } catch {
    return null;
  }
}

/** Dispatched once per burst of 401s from api()/send(). */
export const UNAUTHORIZED_EVENT = 'alder:unauthorized';

let unauthorizedQueued = false;

/** Coalesce concurrent 401s into a single browser event. */
export function signalUnauthorized(): void {
  if (unauthorizedQueued) return;
  unauthorizedQueued = true;
  queueMicrotask(() => {
    unauthorizedQueued = false;
    window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
  });
}
